import React from 'react';
import { CellScope, Table, TableBody, TableCell, TableHead, TableRow } from '../../../components/organisms/Table';
import { TableCellModifier } from '../../../components/organisms/Table/TableCell';
import { isEmptyArray } from '../../../lib/typeGuards';
import { usePageStatistics } from './usePageStatistics';
import { StatisticYearly } from '../PageStatistics.types';
import { DateFormat } from '../../../_lib/components/DateFormat';

type PageStatisticsTableWithTotal = {
  statistics: StatisticYearly[];
  type: 'yearly';
};

/**
 * Table to display statistics that contain only total data.
 */
export function PageStatisticsTableOnlyTotal({ statistics, type }: PageStatisticsTableWithTotal) {
  const { dateTrans, total, totalSubtree, cellModifier, cellModifierLarge, getCaption, getDateFormatByType } =
    usePageStatistics(type);

  if (isEmptyArray(statistics)) {
    return null;
  }

  return (
    <div className="page-statistics">
      <Table caption={getCaption()} captionHidden={false}>
        <TableHead>
          <TableRow>
            <TableCell modifier={cellModifierLarge}>{dateTrans}</TableCell>
            <TableCell modifier={cellModifier}>{total}</TableCell>
            <TableCell modifier={cellModifier}>{totalSubtree}</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {statistics?.map(item => (
            <TableRow key={item.date + type}>
              <TableCell isTableHead modifier={TableCellModifier.LOWPADDING_VERTICAL_CENTER} scope={CellScope.ROW}>
                <DateFormat date={item.date} format={getDateFormatByType()} />
              </TableCell>
              <TableCell modifier={cellModifier} dataHead={total}>
                {item.total}
              </TableCell>
              <TableCell modifier={cellModifier} dataHead={totalSubtree}>
                {item.totalSubTree}
              </TableCell>
            </TableRow>
          ))}
        </TableBody>
      </Table>
    </div>
  );
}
